module.exports = function logout() {
  localStorage.removeItem("vsTokenAdmin");
};
